import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

/**
 * Guard that protects routes requiring authentication.
 * Implements both canLoad (for lazy-loaded modules) and canActivate (for direct navigation).
 */
@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(private navController: NavController, private authService: AuthService) {}

    /**
     * Guard for lazy-loaded modules.
     * Prevents module from loading if user is not authenticated.
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
        const returnUrl = '/' + segments.map(s => s.path).join('/');
        return this.checkAuthentication(returnUrl);
    }

    /**
     * Guard for already-loaded routes.
     * Prevents navigation if user is not authenticated.
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkAuthentication(state.url);
    }

    /**
     * Shared authentication check logic.
     * Waits for authentication state to be determined, then allows or redirects.
     */
    private checkAuthentication(returnUrl: string): Observable<boolean> {
        return this.authService.isAuthenticated.pipe(
            filter(val => val !== null),
            take(1),
            map(isAuthenticated => {
                if (isAuthenticated) {
                    return true;
                }
                    this.navController.navigateRoot(['/auth'], {
                        queryParams: { returnUrl }
                    });
                    return false;

            })
        );
    }
}
